import axios from "axios";
import { domain } from "../Links/Links";

export async function searchRequest(text, setSearchData) {
  const response = await axios.get(domain + "/search/?text=" + text, {
    withCredentials: true,
  });

  console.log(response.data);

  setSearchData(response.data);
}
